if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        init() {
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderVariant(e.detail.html);
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
          });
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options).forEach((option) => {
            option.removeAttribute('selected');
            if (option.selected) option.setAttribute('selected', '');
          });
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        },
        // Single merged variant dropdown: mirror the chosen variant onto the hidden
        // per-option selects so the theme's option_values lookup still resolves it.
        changeOptionMergedSticky(event) {
          const chosen = event.target.selectedOptions[0];
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          let optionValues = [];
          try { optionValues = JSON.parse(chosen.dataset.optionValues || '[]'); } catch (e) {}
          const hiddenSelects = variantEl.querySelectorAll('.sticky-merged-hidden select');
          hiddenSelects.forEach((select, index) => {
            const wanted = optionValues[index];
            Array.from(select.options).forEach((option) => {
              const isMatch = option.value === wanted;
              option.selected = isMatch;
              if (isMatch) {
                option.setAttribute('selected', '');
              } else {
                option.removeAttribute('selected');
              }
            });
          });
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              targetUrl: chosen.dataset.productUrl || '',
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })
}